// File: src/components/Projects.jsx 1
import React from "react";

const projects = [
  { title: "400kV Line Erection", location: "Maharashtra", type: "Transmission" },
  { title: "220kV Substation", location: "Gujarat", type: "EPC" },
  { title: "HT Distribution", location: "Delhi", type: "Infrastructure" },
];

const Projects = () => {
  return (
    <section className="section" id="projects">
      <h2>Our Major Projects</h2>
      <div className="grid-container">
        {projects.map((proj, i) => (
          <div className="form-card" key={i}>
            <div className="card-header">
              <span>{proj.type}</span>
              <h3>{proj.title}</h3>
            </div>
            <p>Location: {proj.location}</p>
            <button className="btn-submit secondary">View Details</button>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Projects;